import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "eating_detection",
  localization: {
    en: {
      title: "Eating detected",
      settingsHeader: "Eating Detection",
    },
    fr: {
      title: "Mangeur détecté",
      settingsHeader: "Détection de Manger",
    }
  },
  proto: {
    name: "EVENT_RAVEN_EATING_DETECTED",
    value: 139
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}
